import { html } from 'lit';

export const Arrow = () => html`
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M63.0351 40L36 13H60.214L95.5269 47.539L95.1858 47.8801L95.5269 48.2212L60.214 82.7602H36L62.795 56H5V40H63.0351Z"
      fill="white"
    />
  </svg>
`;

export const Download = () => html`
  <svg
    title="document icon"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <path
      d="m83.12,23.3v.63h-17.26s0-16.99,0-16.99l17.26,16.36ZM60.19,6v23.6h22.93s0,60.4,0,60.4H13V6h47.19Zm7.55,34.09H29.04v8h38.7v-8Zm-38.7,18.1h38.7v8H29.05v-8Z"
    ></path>
  </svg>
`;

export const Email = () =>
  html`<svg
    title="email icon"
    aria-hidden="true"
    id="icon_email"
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2447 0.5H1.97772L7.01238 5.05794L12.2447 0.5ZM13.8581 0.5L7.01238 6.57679L0.166656 0.5V9.39286H14V0.5H13.8581Z"
      fill="white"
    ></path>
  </svg>`;

export const External = () => html`
  <svg
    title="new window icon"
    id="icon_new_window"
    aria-hidden="true"
    data-name="new-window-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <defs>
      <style>
        .cls-1 {
          fill-rule: evenodd;
        }
      </style>
    </defs>
    <path
      class="cls-1"
      d="m48.91,15.78l27.79-.02-9.18,9.4H11v62.73h63.83v-54l9.34-9.57v26.66s11.78-12.12,11.78-12.12V15.75s.05,0,.05,0V4h-.04s-11.78,0-11.78,0h-23.14s-12.12,11.78-12.12,11.78Zm9.19,19.04l-15.76,16.14,8.01,8.01,14.67-15.02v34.3H20.82v-43.43h37.28Z"
    ></path>
  </svg>
`;
